import React from 'react';
import { QueryClient, QueryClientProvider } from 'react-query';
import { Provider } from 'react-redux';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import './App.scss';

import MainLayoutProgram from 'components/templates/MainLayoutProgram';
import NetworkStatusModal from 'components/templates/NetworkStatusModal';
import useNetworkStatus from 'hooks/useNetworkStatus';
import ConfirmRemake from 'pages/ConfirmRemake';
import Congratulation from 'pages/Congratulation';
import Home from 'pages/Home';
import ScanQRCode from 'pages/ScanQRCode';
import { store } from 'store';

const AppContent: React.FC = () => (
  <Routes>
    <Route element={<MainLayoutProgram />}>
      <Route path="/" element={<Home />} />
      <Route path="/confirm" element={<ConfirmRemake />} />
      <Route path="/quetma-internal" element={<ScanQRCode />} />
      <Route path="/:code" element={<Congratulation />} />
    </Route>
  </Routes>
);

const App: React.FC = () => {
  const queryClient = new QueryClient({
    defaultOptions: {
      queries: {
        retry: 0,
        refetchOnMount: true,
        refetchOnWindowFocus: false,
        refetchOnReconnect: false,
      },
    },
  });

  return (
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <AppContent />
      </BrowserRouter>
    </QueryClientProvider>
  );
};

/**
  * Component khởi tạo lắng nghe mạng.
  * Phải nằm bên trong <Provider> để useNetworkStatus có thể dispatch vào store.
  */
const NetworkInit: React.FC = () => {
  useNetworkStatus();
  return null;
};

const AppWrapper: React.FC = () => (
  <Provider store={store}>
    <NetworkInit />
    <App />
    <NetworkStatusModal />
  </Provider>
);

export default AppWrapper;
